function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "portable-document-format-1");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.557 32.4h-16.201c-1.863-0.002-3.372-1.512-3.375-3.375v-20.251c0.002-1.863 1.512-3.372 3.375-3.375h16.201c1.863 0.002 3.372 1.512 3.375 3.375v20.25c-0.002 1.863-1.512 3.373-3.375 3.376h-0zM11.356 6.75c-1.118 0.001-2.024 0.907-2.025 2.025v20.25c0.001 1.118 0.907 2.024 2.025 2.025h16.201c1.118-0.001 2.024-0.907 2.025-2.025v-20.25c-0.001-1.118-0.907-2.024-2.025-2.025h-0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.956 28.351h-1.351c-1.863-0.002-3.373-1.512-3.375-3.375v-21.601c0.002-1.863 1.512-3.372 3.375-3.375h16.201c1.863 0.002 3.372 1.512 3.375 3.375v0c-0.013 0.363-0.31 0.652-0.675 0.652s-0.662-0.289-0.675-0.651l-0-0.001c-0.001-1.118-0.907-2.024-2.025-2.025h-16.201c-1.118 0.001-2.024 0.907-2.025 2.025v21.601c0.001 1.118 0.907 2.024 2.025 2.025h1.351c0.363 0.013 0.652 0.31 0.652 0.675s-0.289 0.662-0.651 0.675l-0.001 0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.857 22.951h-10.8c-0.007 0-0.015 0-0.024 0-0.373 0-0.675-0.302-0.675-0.675s0.302-0.675 0.675-0.675c0.008 0 0.017 0 0.025 0l-0.001-0h10.8c0.007-0 0.015-0 0.024-0 0.373 0 0.675 0.302 0.675 0.675s-0.302 0.675-0.675 0.675c-0.008 0-0.017-0-0.025-0l0.001 0z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.857 28.35h-10.8c-0.007 0-0.015 0-0.024 0-0.373 0-0.675-0.302-0.675-0.675s0.302-0.675 0.675-0.675c0.008 0 0.017 0 0.025 0l-0.001-0h10.8c0.007-0 0.015-0 0.024-0 0.373 0 0.675 0.302 0.675 0.675s-0.302 0.675-0.675 0.675c-0.008 0-0.017-0-0.025-0l0.001 0z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.857 17.55h-10.8c-0.007 0-0.015 0-0.024 0-0.373 0-0.675-0.302-0.675-0.675s0.302-0.675 0.675-0.675c0.008 0 0.017 0 0.025 0l-0.001-0h10.8c0.007-0 0.015-0 0.024-0 0.373 0 0.675 0.302 0.675 0.675s-0.302 0.675-0.675 0.675c-0.008 0-0.017-0-0.025-0l0.001 0z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M24.857 12.15h-10.8c-0.007 0-0.015 0-0.024 0-0.373 0-0.675-0.302-0.675-0.675s0.302-0.675 0.675-0.675c0.008 0 0.017 0 0.025 0l-0.001-0h10.8c0.007-0 0.015-0 0.024-0 0.373 0 0.675 0.302 0.675 0.675s-0.302 0.675-0.675 0.675c-0.008 0-0.017-0-0.025-0l0.001 0z"
});

var SvgDocFormat = function SvgDocFormat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocFormat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc-format.5f01097b.svg";
export { ForwardRef as ReactComponent };